export const APPLICATION_LIST = "/api/application/list";
export const GROUP_LIST = "/api/group/sub-groups/list";
export const GROUP_SETTING = "/api/user/settings";
export const CREATE_GROUP = "/api/group/create/with-admin";
export const CREATE_USER = "/api/user/create";
export const CREATE_GROUP_CSV = "/api/bulk-actions/create/group";
export const CREATE_USER_CSV = "/api/bulk-actions/create/user";
export const GROUP_CHILDREN_HIERARCHY = "/api/group/all/children/hierarchy";
export const GROUP_CHILDREN_LIST = "/api/group/all/children/list";
export const GROUP_CHILDREN_USERS = "/api/group/all/children/users";
export const CHANGE_PARENT = "/api/group/change/parent";
export const UPDATE_USER = "/api/user/update/details";
export const USER_DETAILS = "/api/group/user/details";
export const GROUP_UPDATE = "/api/user/group/edit";
export const GROUP_DETAILS = "/api/group/details";
export const GROUP_USERS_LIST = "/api/group/users/list";
export const UPLOAD_GROUP_LOGO = "/api/user/upload/logo";
export const UPLOAD_USER_AVATAR = "/api/user/upload/avatar";
export const ASSIGN_APPLICATION_LIST = "/api/application/assigned";
export const ALLOCATED_APPLICATION_LIST = "/api/application/allocated/list";
export const ALLOCATED_MODULE_LIST = "/api/resource/allocated/list";
export const GROUP_BREADCRUMB = "/api/group/breadcrumb";
export const DELETE_ALLOCATION = "/api/allocation/delete";
export const ASSIGN_RESOURCE = "/api/allocation/resource/assign";
export const ALL_PERMISSION_LIST = "/api/role/all/permission/list";
export const MULTIPLE_CHANGE_STATUS = "/api/bulk-actions/change/status";
export const APPLICATION_RESOURCE_COUNT = "/api/application/resource/assigned";
export const TAG_LIST = "/api/tag/list";
export const ASSIGNED_RESOURCE_APPLICATION = "/api/resource/list";
export const FETCH_USER_WITH_ASSIGNED_RESOURCE_COUNT = '/api/user/details/assigned';
export const FETCH_METRICS = '/api/group/metrics/total';
export const ALLOCATE_RESOURCE_SIDEBAR = '/api/resource/allocate/side/bar/list';
export const ALLOCATE_RESOURCE_FILTER = '/api/resource/allocate/filter';
export const UPDATE_PASSWORD = '/api/user/change/password';
export const FORGOT_PASSWORD = '/api/auth/forgot/password';
export const PUBLIC_ROLES = '/api/role/all/list/PUBLIC';
export const USER_ROLES = '/api/role/assigned/list';
export const DELETE_ROLE = '/api/role/delete';
export const PRIVATE_ROLES = '/api/role/all/list/PRIVATE';
export const DEFAULT_ROLES = '/api/role/all/list/DEFAULT';
export const CREATE_ROLE = "/api/role/new/create";
export const UPDATE_ROLE_DETAILS = "/api/role/update/details";
export const GET_ROLE_DETAILS = "/api/role/details";
export const ROLE_USERS = "/api/role/users/list";
export const UPDATE_ROLE_USERS = "/api/role/update/users";
export const DELETE_ROLE_USERS = "/api/role/delete/users";
export const SET_NEW_PASSWORD="/api/auth/set-new-password";

export const TAG_CATEGORY_DETAILS = "/api/tag/tagCategory/details"